export const result = {
  header: {
    uri: 'https://api.os.uk/search/places/v1/postcode?postcode=NW1%206XE',
    query: 'postcode=NW1 6XE',
    offset: 0,
    totalresults: 10,
    format: 'JSON',
    dataset: 'DPA',
    lr: 'EN,CY',
    maxresults: 100,
    epoch: '121',
    lastupdate: '2025-10-14',
    output_srs: 'EPSG:27700'
  },
  results: [
    {
      DPA: {
        UPRN: '10033619968',
        UDPRN: '50825076',
        ADDRESS: "EMILIA'S CRAFTED PASTA, 215, BAKER STREET, LONDON, NW1 6XE",
        ORGANISATION_NAME: "EMILIA'S CRAFTED PASTA",
        BUILDING_NUMBER: '215',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '2',
        X_COORDINATE: 527870.4,
        Y_COORDINATE: 182081.17,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CR07',
        CLASSIFICATION_CODE_DESCRIPTION: 'Restaurant / Cafeteria',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158430',
        WARD_CODE: 'E05013805',
        PARENT_UPRN: '10033659670',
        LAST_UPDATE_DATE: '20/01/2025',
        ENTRY_DATE: '13/02/2013',
        BLPU_STATE_DATE: '13/02/2013',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1H'
      }
    },
    {
      DPA: {
        UPRN: '10033619969',
        UDPRN: '50825094',
        ADDRESS: 'FLAT 1-86, 219, BAKER STREET, LONDON, NW1 6XE',
        SUB_BUILDING_NAME: 'FLAT 1-86',
        BUILDING_NUMBER: '219',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527868.08,
        Y_COORDINATE: 182090.78,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'PP',
        CLASSIFICATION_CODE_DESCRIPTION: 'Property Shell',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158430',
        WARD_CODE: 'E05013805',
        PARENT_UPRN: '10033659670',
        LAST_UPDATE_DATE: '20/01/2025',
        ENTRY_DATE: '13/02/2013',
        BLPU_STATE_DATE: '13/02/2013',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '7J'
      }
    },
    {
      DPA: {
        UPRN: '10033625299',
        UDPRN: '54761212',
        ADDRESS:
          'PARKVIEW ESTATES MANAGEMENT LTD, 219, BAKER STREET, LONDON, NW1 6XE',
        ORGANISATION_NAME: 'PARKVIEW ESTATES MANAGEMENT LTD',
        BUILDING_NUMBER: '219',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527868.08,
        Y_COORDINATE: 182090.78,
        STATUS: 'HISTORICAL',
        LOGICAL_STATUS_CODE: '8',
        CLASSIFICATION_CODE: 'CL06',
        CLASSIFICATION_CODE_DESCRIPTION:
          'Indoor / Outdoor Leisure / Sporting Activity / Centre',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '4',
        BLPU_STATE_CODE_DESCRIPTION: 'No longer existing',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158430',
        WARD_CODE: 'E05013805',
        LAST_UPDATE_DATE: '22/02/2024',
        ENTRY_DATE: '20/10/2014',
        BLPU_STATE_DATE: '25/11/2022',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1G'
      }
    },
    {
      DPA: {
        UPRN: '100022723861',
        UDPRN: '17646245',
        ADDRESS: '235, BAKER STREET, LONDON, NW1 6XE',
        BUILDING_NUMBER: '235',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527850.0,
        Y_COORDINATE: 182134.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'PP',
        CLASSIFICATION_CODE_DESCRIPTION: 'Property Shell',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158434',
        WARD_CODE: 'E05013805',
        LAST_UPDATE_DATE: '10/02/2016',
        ENTRY_DATE: '19/03/2001',
        BLPU_STATE_DATE: '19/03/2001',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '2H'
      }
    },
    {
      DPA: {
        UPRN: '100023072608',
        UDPRN: '17646236',
        ADDRESS: '237, BAKER STREET, LONDON, NW1 6XE',
        BUILDING_NUMBER: '237',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527850.0,
        Y_COORDINATE: 182139.0,
        STATUS: 'HISTORICAL',
        LOGICAL_STATUS_CODE: '8',
        CLASSIFICATION_CODE: 'CR08',
        CLASSIFICATION_CODE_DESCRIPTION: 'Shop / Showroom',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '4',
        BLPU_STATE_CODE_DESCRIPTION: 'No longer existing',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158435',
        WARD_CODE: 'E05013805',
        LAST_UPDATE_DATE: '22/02/2024',
        ENTRY_DATE: '19/03/2001',
        BLPU_STATE_DATE: '01/10/2013',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '2G'
      }
    },
    {
      DPA: {
        UPRN: '100023071949',
        UDPRN: '17646242',
        ADDRESS: 'SHERLOCK HOLMES MUSEUM, 221B, BAKER STREET, LONDON, NW1 6XE',
        ORGANISATION_NAME: 'SHERLOCK HOLMES MUSEUM',
        BUILDING_NAME: '221B',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '2',
        X_COORDINATE: 527847.0,
        Y_COORDINATE: 182144.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CR08',
        CLASSIFICATION_CODE_DESCRIPTION: 'Shop / Showroom',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158436',
        WARD_CODE: 'E05013805',
        LAST_UPDATE_DATE: '23/09/2018',
        ENTRY_DATE: '19/03/2001',
        BLPU_STATE_DATE: '19/03/2001',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1F'
      }
    },
    {
      DPA: {
        UPRN: '10033605426',
        UDPRN: '17646231',
        ADDRESS: 'LONDON BEATLES STORE, 231-233, BAKER STREET, LONDON, NW1 6XE',
        ORGANISATION_NAME: 'LONDON BEATLES STORE',
        BUILDING_NAME: '231-233',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527854.0,
        Y_COORDINATE: 182123.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CR08',
        CLASSIFICATION_CODE_DESCRIPTION: 'Shop / Showroom',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158432',
        WARD_CODE: 'E05013805',
        PARENT_UPRN: '100023072617',
        LAST_UPDATE_DATE: '10/02/2016',
        ENTRY_DATE: '25/02/2009',
        BLPU_STATE_DATE: '25/02/2009',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1A'
      }
    },
    {
      DPA: {
        UPRN: '10033529292',
        UDPRN: '17646238',
        ADDRESS: 'TOTAL CHI, 241-243, BAKER STREET, LONDON, NW1 6XE',
        ORGANISATION_NAME: 'TOTAL CHI',
        BUILDING_NAME: '241-243',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '2',
        X_COORDINATE: 527844.0,
        Y_COORDINATE: 182155.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CR08',
        CLASSIFICATION_CODE_DESCRIPTION: 'Shop / Showroom',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158438',
        WARD_CODE: 'E05013805',
        PARENT_UPRN: '100023071621',
        LAST_UPDATE_DATE: '23/09/2018',
        ENTRY_DATE: '27/04/2003',
        BLPU_STATE_DATE: '27/04/2003',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1B'
      }
    },
    {
      DPA: {
        UPRN: '10033529295',
        UDPRN: '52154612',
        ADDRESS: 'FLAT 1-5, 245-247, BAKER STREET, LONDON, NW1 6XE',
        SUB_BUILDING_NAME: 'FLAT 1-5',
        BUILDING_NAME: '245-247',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527839.0,
        Y_COORDINATE: 182163.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'PP',
        CLASSIFICATION_CODE_DESCRIPTION: 'Property Shell',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158439',
        WARD_CODE: 'E05013805',
        LAST_UPDATE_DATE: '10/02/2016',
        ENTRY_DATE: '27/04/2003',
        BLPU_STATE_DATE: '27/04/2003',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1E'
      }
    },
    {
      DPA: {
        UPRN: '10033625010',
        UDPRN: '17646244',
        ADDRESS: 'THE VOLUNTEER, 245-247, BAKER STREET, LONDON, NW1 6XE',
        ORGANISATION_NAME: 'THE VOLUNTEER',
        BUILDING_NAME: '245-247',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'LONDON',
        POSTCODE: 'NW1 6XE',
        RPC: '1',
        X_COORDINATE: 527839.0,
        Y_COORDINATE: 182163.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CR06',
        CLASSIFICATION_CODE_DESCRIPTION: 'Public House / Bar / Nightclub',
        LOCAL_CUSTODIAN_CODE: 5990,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'CITY OF WESTMINSTER',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000005158439',
        WARD_CODE: 'E05013805',
        PARENT_UPRN: '10033529295',
        LAST_UPDATE_DATE: '17/05/2019',
        ENTRY_DATE: '02/10/2014',
        BLPU_STATE_DATE: '02/10/2014',
        LANGUAGE: 'EN',
        MATCH: 1.0,
        MATCH_DESCRIPTION: 'EXACT',
        DELIVERY_POINT_SUFFIX: '1R'
      }
    }
  ]
}
